import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "body-wrapper container-xxl" }
const _hoisted_3 = { class: "content-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppHeader = _resolveComponent("AppHeader")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_AppSidebar = _resolveComponent("AppSidebar")!
  const _component_LogoutTimerModal = _resolveComponent("LogoutTimerModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_AppHeader),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_view)
        ]),
        _createVNode(_component_AppSidebar)
      ])
    ]),
    _createVNode(_component_LogoutTimerModal, { visible: _ctx.getLogoutModal }, null, 8, ["visible"])
  ], 64))
}